export const Marquee = ({ items, dark = true }) => {
    const row = [...items, ...items];
    return (
        <div className={`overflow-hidden py-8 ${dark ? "bg-navy-deep" : "bg-white"} border-y ${dark ? "border-white/10" : "border-slate-200"}`}>
            <div className="animate-marquee">
                {row.map((t, i) => (
                    <span key={i} className="mx-8 inline-flex items-center gap-8">
                        <span className={`font-display font-extrabold text-4xl sm:text-6xl uppercase tracking-tight ${dark ? "text-outline" : "text-outline-navy"}`}>
                            {t}
                        </span>
                        <span className="text-brand text-3xl">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
